const FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

let lastFocused = null;

const trapFocus = (el) => {
	const focusable = [...el.querySelectorAll(FOCUSABLE)];
	const first = focusable[0];
	const last = focusable[focusable.length - 1];

	el.addEventListener('keydown', (e) => {
		if (e.key !== 'Tab') return;
		if (e.shiftKey) {
			if (document.activeElement === first) { e.preventDefault(); last.focus(); }
		} else {
			if (document.activeElement === last) { e.preventDefault(); first.focus(); }
		}
	});
};

const openPopup = (key) => {
	const popup = document.querySelector(`.popup[data-popup="${key}"]`);
	if (!popup) return;

	lastFocused = document.activeElement;

	popup.removeAttribute('hidden');
	popup.setAttribute('aria-hidden', 'false');
	document.body.style.overflow = 'hidden';

	// Focus first focusable element
	const firstFocusable = popup.querySelector(FOCUSABLE);
	if (firstFocusable) firstFocusable.focus();

	trapFocus(popup);
};

const closePopup = (popup) => {
	popup.setAttribute('hidden', '');
	popup.setAttribute('aria-hidden', 'true');
	document.body.style.overflow = '';
	if (lastFocused) lastFocused.focus();
};

const closeAll = () => {
	document.querySelectorAll('.popup:not([hidden])').forEach(closePopup);
};

// Open triggers
document.querySelectorAll('[data-popup-menu]').forEach(trigger => {
	trigger.addEventListener('click', (e) => {
		e.preventDefault();
		openPopup(trigger.dataset.popupMenu);
	});
});

// Close buttons inside popups
document.querySelectorAll('.popup__close').forEach(btn => {
	btn.addEventListener('click', () => closePopup(btn.closest('.popup')));
});

// Click backdrop
document.querySelectorAll('.popup__backdrop').forEach(backdrop => {
	backdrop.addEventListener('click', () => closePopup(backdrop.closest('.popup')));
});

// Escape key
document.addEventListener('keydown', (e) => {
	if (e.key === 'Escape') closeAll();
});
